import { render, staticRenderFns } from "./MiuList.vue?vue&type=template&id=7735f83c&scoped=true"
import script from "./MiuList.vue?vue&type=script&lang=js"
export * from "./MiuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7735f83c",
  null
  
)

export default component.exports